import { defineComponent } from 'vue'

export default defineComponent({
    data() {
        return {
            currentDelayValue: 500,
            currentRetry: 0,
            valueAtMax: false,

            retryMultiplier: 1.6,
            jitterValue: 12,

            maxDelayValue: 4500,
            maxRetry: 12
        }
    },
    methods: {
        getDelayValue() {
            if (!this.valueAtMax) {
                if (this.currentRetry > 0) {
                    if (this.currentRetry> (this.maxRetry/ 2)) {
                        this.currentDelayValue = Math.min(this.currentDelayValue * this.retryMultiplier, this.maxDelayValue);
                    }
                    this.valueAtMax = this.currentDelayValue >= this.maxDelayValue
                }
            }
            // Add random jitter (+ / -)
            this.currentDelayValue += this.jitterOutput;

            this.currentRetry++

            if (this.currentRetry > this.maxRetry) return 0;
            return this.currentDelayValue
        }
    },
    computed: {
        jitterOutput() {
            return Math.random() * this.jitterValue
        }
    }
})
